export const AUTH_TOKEN = "OA_ADMIN_AUTH_TOKEN";
